module.exports = __webpack_public_path__ + "img/Retailer_learning_one.153a7a18.png";